// extracted by mini-css-extract-plugin
export var filterIncDec = "_4z-0";
export var leftBorder = "_4z-1";
export var rightBorder = "_4z-2";
export var stringInput = "_4z-3";